import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable, Subject } from 'rxjs';
import { BehaviorSubject } from 'rxjs';

import * as crypto from 'crypto-js';
import {DwAuthService, DW_AUTH_TOKEN, DwUserService, DwSystemConfigService, DW_APP_AUTH_TOKEN, DwRoutingMessageService} from '@webdpt/framework';
// import { CustUserService } from './cust-user.service';
import { LocalStorage } from '@webdpt/framework';
import { APP_DEFAULT, LONIG_DEFAULT, DW_USING_FRSSO } from '@webdpt/framework';
import { IDwRequestOptions } from '../../../../../projects/webdpt/framework/http/interface';
import { CookieService } from 'ng2-cookies';
import { FxDapHttpClient } from 'app/implementation/shared/fx-http-client';
import { SseService } from 'app/notification/sse.service';
import { takeUntil } from 'rxjs/operators';


@Injectable()
export class FxAuthService extends DwAuthService {
  //loginSubject: BehaviorSubject<boolean>; // 廣播登入狀態
  //loginSuccess = (this.custUserService.userInfo['isLoggedin'] && JSON.parse(this.custUserService.userInfo['isLoggedin'])) ? true : false;

  private sseDestroyed$ :Subject<void> = new Subject<void>();

  private isSseDestroyed:boolean=false;
  

 
  constructor(
    protected custRouter: Router,
    protected custUserService: DwUserService,
    protected custStorage: LocalStorage,
    protected http: HttpClient,
    public dapHttp: FxDapHttpClient,
    public dwMessage: DwRoutingMessageService,
    @Inject(DW_AUTH_TOKEN) protected authToken: any,
    @Inject(APP_DEFAULT) private custDefaultApp: any,
    @Inject(LONIG_DEFAULT) protected defaultLogin: string,
    @Inject(DW_USING_FRSSO) protected usingFrSSO: boolean,
    protected configService: DwSystemConfigService,
    @Inject(DW_APP_AUTH_TOKEN) private dwAppAuthToken: string,
    private cookieService: CookieService,
    private sseService:SseService
  ) {
    super(custRouter, custUserService, custStorage, http, authToken, custDefaultApp, defaultLogin, usingFrSSO, configService);
  
    this.configService.getConfig().subscribe(
      config => {
        //this.msgURL = config.msgUrl + 'api/emc/v1/';
        //this.iamURL = config.iamUrl + 'api/iam/v2/';
        this.sseService.setApi(config.apiUrl);
        //David Li 05Aug2024
        this.isLoggedIn$.subscribe(
          value => {
            if (!value) {
              console.log("DavikdLee:登出成功,取消推送订阅");
              this.fxLogout();
              this.sseService.close();
            }else{
              console.log("DavidLee:登入成功，订阅推送");
              //this.sseService.getFxEventSource().pipe(  
              //  takeUntil(this.sseDestroyed$)  
              //).subscribe(data => {

            this.sseService.getFxEventSource().subscribe(data => {
              console.log('data:', data)
            }, error => {
              console.log('error', error)
            }, () => {
              console.log('complete')
            });
      
          }
        });
      }
    );

    
    if(this.isSseDestroyed){

      this.isSseDestroyed=false;

      this.sseService.getFxEventSource().subscribe(data => {
        console.log('data:', data)
      }, error => {
        console.log('error', error)
      }, () => {
        console.log('complete')
      });
  
    } 
  }

  public login(userConfig: any): Observable<any> {
    const info = {
      success: false,
      description: '', // 登入失敗時, 顯示.
      isFirstLogin: false,  //是否是首次登陆
      data: {} //登录返回信息
    };

    return new Observable((observer): void => {
      //this.logining().subscribe(
      //  result => {
      //    if (!result) {
      //      info.success = false;
      //      info.description = '登入失敗';
      //      observer.next(info);
      //      observer.complete();
      //      return;
      //    }

          //密码md5编码一下
          //如果是客服系统进入
          var md5_password = '';
          if (userConfig.isCServer) {
            md5_password = userConfig.password;
          } else {
            //密码md5编码一下
            md5_password = crypto.MD5(userConfig.password)+'';
          }

          let userParam;
          // debugger
          console.log("md5_password:"+md5_password,userConfig.password);
          //新登录页添加新参数判断入参
          if(userConfig.saas != undefined) {
            userParam = {
              userId: userConfig.userId,  // 类型：String  必有字段  备注：无, userId可輸入id, email, mobilephone.
              password: md5_password, // 类型：String  必有字段  备注：與password兩者擇一
             // ent: userConfig.ent  ,    // 类型：String  必有字段  备注：无
              language: userConfig.language ,    // 类型：String  语言
              scend: userConfig.scend, //类型 Boolean 二次登陆
              saas: true,
              ati:this.cookieService.get("_ati")
            };
          } else {
            userParam = {
              userId: userConfig.userId,  // 类型：String  必有字段  备注：无, userId可輸入id, email, mobilephone.
              password: md5_password, // 类型：String  必有字段  备注：與password兩者擇一
              ent: userConfig.ent  ,    // 类型：String  必有字段  备注：无
              language: userConfig.language ,    // 类型：String  语言
              scend: userConfig.scend, //类型 Boolean 二次登陆
              ati:this.cookieService.get("_ati")
            };
          }



          console.log('userConfig.captchaKey:',userConfig.captchaKey);
          console.log('-----------:',userConfig.language);
          //有验证码登录
          if(userConfig.captchaKey.isCaptcha){
            
            this.http.post('A/ILoginService/login', {
              param: userParam, captchaDataMap: userConfig.captchaKey
            }, this.addDefaultOption()).subscribe((response: any) => {
              console.log('login response:', response);
              if (!response.token) {
                window.location.href = response.redirectUrl;
              } else {
                let token = {id: 'token', value: response.token};
                this.userService.setUser(token);
                sessionStorage.setItem('token', response.token); //缓存token
                let userId = {id: 'userId', value: userConfig.userId};
                this.userService.setUser(userId);
                this.setLogined(userId);
                //console.log('token:',this.userService.userInfo['token']);
                let data = JSON.parse(response.data);
                console.log("response.data.isFirstLogin:",data.isFirstLogin);
                if(data.isFirstLogin === 'Y'){
                  info.isFirstLogin = true;
                }
                info.success = true;
                info.data = response;
              }
              observer.next(info);
              observer.complete();
              return;
            },(error:any) => {
              console.log('登录error:',error);
              this.dwMessage.error(error.error.errorMessage);
              info.success = false;
              info.description = error.error.errorMessage;
              observer.error(info);
              observer.complete();
            });
          }else{  //无验证码登录
            this.http.post('A/ILoginService/login', {
              param: userParam
            }, this.addDefaultOption()).subscribe((response: any) => {
              console.log('login response:', response);
              if (!response.token) {
                window.location.href = response.redirectUrl;
              } else {
                let token = {id: 'token', value: response.token};
                this.userService.setUser(token);
                sessionStorage.setItem('token', response.token); //缓存token
                let userId = {id: 'userId', value: userConfig.userId};
                this.userService.setUser(userId);
                this.setLogined(userId);
                //console.log('token:',this.userService.userInfo['token']);
                let data = JSON.parse(response.data);
                console.log("response.data.isFirstLogin:",data.isFirstLogin);
                if(data.isFirstLogin === 'Y'){
                  info.isFirstLogin = true;
                }
                info.success = true;
                info.data = response;
              }
              observer.next(info);
              observer.complete();
              return;
            },(error:any) => {
              console.log('登录error:',error);
              this.dwMessage.error(error.error.errorMessage);
              info.success = false;
              info.description = error.error.errorMessage;
              observer.error(info);
              observer.complete();
            });
          }

          /*this.http.post(this.iamURL + 'identity/login', this.userConfig)
            .subscribe((userData) => {
              console.log('userData>>>>>>>', userData);
              if (!userData) {
                info.success = false;
                info.description = '登入失敗';
                observer.next(info);
                observer.complete();
                return;
              }

              this.setLogined(userData);
              observer.next(info);
              observer.complete();
              return;
            },
            error => {
              observer.error(error)
              observer.complete();
            }
            );*/
        }
      );
    //});
  }

  private addDefaultOption(options?: IDwRequestOptions): any {
    const localOptions = options || {};

    let headers: HttpHeaders;
    if (localOptions.headers instanceof HttpHeaders) {
      headers = localOptions.headers;
    } else {
      headers = new HttpHeaders(localOptions.headers);
    }

    const localHeaders = {'ati-cookie': document.cookie || '', 'local-ip': localStorage.getItem('local_cip') || '', 'jdid': localStorage.getItem('jd_eid')|| ''};

    headers = Object.keys(localHeaders)
      .reduce((acc, name) => (acc.has(name)) ? acc : acc.set(name, localHeaders[name]), headers);


    return {
      headers,
      observe: 'body',
      params: [],
      reportProgress: localOptions.reportProgress,
      responseType: 'json',
      withCredentials: localOptions.withCredentials
    };
  }

  //设置登录token\user等实例
  // public setLoginInfo(response: any): Observable<any> {
  //   return new Observable((observer): void => {
  //     let token = {id: 'token', value: response.token};
  //     this.userService.setUser(token);
  //     let userId = {id: 'userId', value: response.userId};
  //     this.userService.setUser(userId);
  //     this.setLogined(userId);
  //     //console.log('token:',this.userService.userInfo['token']);
  //     let data = JSON.parse(response.data);
  //     console.log("response.data.isFirstLogin:",data.isFirstLogin);
  //     if(data.isFirstLogin === 'Y'){
  //       response.isFirstLogin = true;
  //     }
  //     observer.next(response);
  //     observer.complete();
  //   });
  // }

    /**
   * 用户登出.
   *
   * returns void.
   */
    protected fxLogout(): void {
      // 當 token 不存在時, 無需進行登出.
      if (!this.authToken.token) {
        this.userService.clearUserInfo();
        this.userService.clearUser();
        sessionStorage.clear();
        return;
      }
  
      //调用分销的登出方法
      this.dapHttp.post('A/ILoginService/logout', {}).subscribe(
      response => {
        this.userService.clearUserInfo();
        this.userService.clearUser();
        sessionStorage.clear();
        
      }, error => {
        this.userService.clearUserInfo();
        this.userService.clearUser();
        sessionStorage.clear();
       
      }, () => {
         //console.log('Observer got a complete notification');
      });

      //用户登出时销毁时活取消消息推送的所有订阅，以防止内存泄漏。
      this.sseDestroyed$.next();  
      this.sseDestroyed$.complete();   
      this.isSseDestroyed=true;


    }

}
